export const initialValuesEditUser =

	{
        /*User information*/
		user: {
			firstname: "",
			lastname: "",
			phone: "",
			email: "",
			gender: "",
			agencyName: "",
			roles:{
				additionalProp1: ""
			},
		},

	}
